//在此处编写调用授权等基本平台接口
import store from '@/store/'
class oc_api {
    constructor(axiosFactory) {
        this.$http = axiosFactory;
    }
    http() {
        return this.$http;
    }
    get(url, cb) {
        this.$http.get(url).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    gets(url, data, cb) {
        this.$http.get(url, data).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    post(url, data, cb) {
        this.$http.post(url, data).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    posts(url, cb) {
        this.$http.post(url).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    put(url, data, cb) {
        this.$http.put(url, data).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    puts(url, cb) {
        this.$http.put(url).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    delete(url, data, cb) {
        this.$http.delete(url, data).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }
    deletes(url, cb) {
        this.$http.delete(url).then(res => {
            cb(res.data);
        }).catch(err => {
            cb(err);
        });
    }

  //获取预览简历的二进制流
  getPreviewResume(fileId,cb){
      this.$http.get(`/my/resume/appendix/${fileId}/see`,{responseType: "blob",
      }).then(res=>{
        let blob = res.data;
        let url = window.URL.createObjectURL(blob);
        cb(url);
      })
  }

    //简历接口
    //上传简历
    postMyresume(data, cb) {
            this.post(`/my/resume/appendixes`, data, cb)
        }
        //查看简历
    getMyresume(cb) {
            this.get(`/my/resume/appendixes`, cb)
        }
        //删除简历
    deleteMyresume(fileId, cb) {
        this.deletes(`/my/resume/appendix/${fileId}`, cb)
    }


    //先判定本地是否存储，如果没有能够获取到本地存储，再次从远程获取；
    //name存储字段，url请求地址，cb回调函数
    getStorageData(name, url, cb) {
            var myObj = JSON.parse(localStorage.getItem(name));
            if (myObj) {
                cb(myObj);
            } else {
                this.$http.get(url).then(res => {
                    cb(res.data);
                    localStorage.setItem(name, JSON.stringify(res.data));
                });
            }
        }
        // ------------------------------------------------------------------------------------
        //猎头公司信息
    getcompanyData(hunterName, cb) {
            this.get(`/hunter/${hunterName}/company`, cb);
        }
        //职聊
        //[求职者]修改推荐记录的状态
    getPositions(positionId, cb) {
            this.get(`/chat/positionId/${positionId}`, cb)
        }
        //判断职位是否关闭
    getMyOperation(positionId, cb) {
            this.get(`/position/${positionId}/operation`, cb)
        }
        //判断职位是否关闭,企业直招
    getCompanyMyOperation(positionId, cb) {
            this.get(`/position/${positionId}/operation`, cb)
        }
        //求职者修改推荐记录的状态
    putRecommendStatus(recommendId, condition, cb) {
        this.put(`/recommend/${recommendId}/recommendStatus`, condition, cb);
    }
    postSendDelegate(data, cb) {
        this.post("/applicant/hunter/delegate", data, cb);
    }
    getchatProfile(userName, cb) {
        this.get(`/chat/applicant/${userName}/profile`, cb);
    }
    getchatothersProfile(userName, cb) {
        this.get(`/chat/hunter/${userName}/profile`, cb);
    }
    getchatothersProfileHr(userName, cb) {
            this.get(`/chat/hr/${userName}/profile`, cb);
        }
        //获得职聊数据
    getchatInformation(cb) {
        this.get(`/chat/applicant/chatList/hunters`, cb);
    }
    getchatAttention(data, cb) {
            this.get(
                `/chat/applicant/hunter/attentions?AttentionStatus=${data}&pageSize=50&pageNum=1`,
                cb
            );
        }
        //关注
    getiscanAttention(data, cb) {
        this.put("/my/resume/canAttention", data, cb);
    }
    getrecommendApply(cb) {
            this.get("/my/recommend/apply/status", cb);
        }
        //发送邮箱激活邮件
    getEmailsend(cb) {
            this.get("/applicant/email/active/send", cb);
        }
        //邮箱激活验证通过
    getEmailactive(userName, toke, cb) {
            this.get(`/my/email/active?userName=${userName}&toke=${toke}`, cb);
        }
        //职位详情
    getHunterPosition(positionId, cb) {
            this.get("/position/" + positionId + "/detail/withPublisher?pageSize=6&pageNum=1", cb);
        }
        //企业直招职位详情
    getCompanyPositions(positionId, cb) {
            this.get("/applicant/" + positionId + "/detail?pageSize=6&pageNum=1", cb);
        }
        // [人才职位服务]职位详情-收藏职位
    getPostFavoritePositions(data, cb) {
            this.post("/my/favoritePositions", data, cb);
        }
        //职位详情--可能感兴趣
    getCanRecommendPosition(cb) {
            this.get(
                "/applicant/position/intelligent/recommend?pageSize=10&pageNum=1",
                cb
            );
        }
        //职位详情--删除感兴趣的职位
    delPositionNotInterested(positionId, cb) {
            this.posts(
                "/applicant/position/intelligent/notInterested/" + positionId,
                cb
            );
        }

        //职位详情--申请职位
    getApplyRecommend(positionId, cb) {
            this.posts("/my/position/" + positionId + "/apply", cb);
        }
        //人脉--推荐猎头;
    getHunterToApplicant(pageSize, cb) {
            this.get("/applicant/hunter/recommend?pageNum=1&pageSize=" + pageSize, cb);
        }
        //人脉--关注猎头的列表
    getAttentionHunterPage(obj, cb) {
            this.get(
                "/applicant/attention/hunter/page?pageSize=15&pageNum=" +
                obj.pageNum +
                "&AttentionStatus=" +
                obj.AttentionStatus,
                cb
            );
        }
        //人脉--关注（取消关注）
    getDelAttention(attentionName, cb) {
            this.deletes(
                "/attention/applicant/hunter/${attentionName}" + attentionName,
                cb
            );
        }
        //首页个人信息
    getBasicInfo(cb) {
        this.get("/my/personalCard", cb);
    }
    createUsers(formItem, cb) {
            this.post("/users", formItem, cb);
        }
        //推荐猎头--关注
    getAttentionHunter(data, cb) {
            this.post("/attention/applicant/hunter", data, cb);
        }
        //首页--推荐猎头给求职者
    getApplicant(cb) {
            this.get("/applicant/hunter/recommend?pageNum=1&pageSize=15", cb);
        }
        //投递（随机推荐职位）
    getRecommendsPosition(pageSize, cb) {
            this.get("/applicant/expect/recommend/positions?pageNum=1&pageSize=" + pageSize, cb);
        }
        //应聘职位
    getPostPositionApplys(positionId, cb) {
            this.posts("/my/position/" + positionId + "/apply", cb);
        }
        //删除已经应聘的职位
    getDelPositionApply(recommendId, cb) {
            this.deletes("/my/apply/" + recommendId, cb);
        }
        //取消收藏
    getDelFavoritePosition(recommendId, cb) {
            this.deletes("/my/favoritePosition/" + recommendId, cb);
        }
        //启用或者禁用职位订阅器
    getPutEnables(data, cb) {
            this.put("/my/positions/subscriber/enable", data, cb);
        }
        //获取已收藏的职位(职位里面)
    getFavoritePositions(pageNum, status, cb) {
            if (status == 'all')
                this.get(`/my/favoritePositions?pageNum=${pageNum}&pageSize=15`, cb)
            else
                this.get(`/my/favoritePositions?pageNum=${pageNum}&pageSize=15&status=${status}`, cb)
        }
        //获取职位订阅内容
    getSubscriber(cb) {
            this.get("/my/positions/subscriber", cb);
        }
        //修改职位订阅
    getPutJobSubscriber(data, cb) {
            this.put("/my/positions/subscriber", data, cb);
        }
        //职位热门搜索
    getHotPositions(cb) {
            this.get("/configs/hotPositions", cb);
        }
        //获取职位
    getPostPositions(pageNum, data, cb) {
            this.post("/positions/search?pageSize=15&pageNum=" + pageNum, data, cb);
        }
        //获取求职者最后一份工作经历
    getLastWork(cb) {
            this.get("/my/resume/latestWork", cb);
        }
        //获取已投递的职位(职位里面)
    getMyPosition(pageNum, applyProgress, cb) {
            if (applyProgress == 'all')
                this.get("/my/positions/applies?pageSize=15&pageNum=" + pageNum, cb);
            else
                this.get("/my/positions/applies?pageSize=15&pageNum=" + pageNum + "&applyProgress=" + applyProgress, cb);
        }
        //获取简历信息
    getResumes(cb) {
            this.get("/my/resume", cb);
        }
        //刷新简历
    getRefresh(cb) {
            this.puts("/my/resume/refresh", cb);
        }
        //简历完善度
    getAppraise(cb) {
            this.get("/my/resume/appraise", cb);
        }
        //个人基本信息
    getPutProfile(data, cb) {
            this.put("/my/resume/profile", data, cb);
        }
        //基本信息   2020.3.18查 没用到的接口
    getPutBasic(data, cb) {
            this.put("/my/resume/basic", data, cb);
        }
        //[职位推荐服务][求职者]获取自己简历应聘，查阅，反馈的统计数
    getMyRecommendApplyStatus(cb) {
            this.get("/my/recommend/apply/status", cb);
        }
        //求职意向
    getPutExpect(data, cb) {
            this.put("/my/resume/expect", data, cb);
        }
        //工作经历
    getPutWorks(workId, data, cb) {
        this.put("/my/resume/work/" + workId, data, cb);
    }
    getPostWorks(data, cb) {
        this.post("/my/resume/works", data, cb);
    }
    getDeleteWorks(workId, cb) {
            this.deletes("/my/resume/work/" + workId, cb);
        }
        //项目经验
    getPutProjects(projectId, data, cb) {
        this.put("/my/resume/project/" + projectId, data, cb);
    }
    getPostProjects(data, cb) {
        this.post("/my/resume/projects", data, cb);
    }
    getDeleteProjects(projectId, cb) {
            this.deletes("/my/resume/project/" + projectId, cb);
        }
        //教育经历
    getPostEducations(data, cb) {
        this.post("/my/resume/educations", data, cb);
    }
    getPutEducations(educationId, data, cb) {
        this.put("/my/resume/education/" + educationId, data, cb);
    }
    getDeleteEducation(educationId, cb) {
            this.deletes("/my/resume/education/" + educationId, cb);
        }
        //语言能力
    addEditLanguage(data, cb) {
            this.put("/my/resume/languages", data, cb);
        }
        //2020.3.18  检查没用到的接口
    getDeleteLanguage(code, cb) {
            this.deletes("/my/resume/language/" + code, cb);
        }
        //培训经历
    getEditTrain(trainId, data, cb) {
        this.put("/my/resume/train/" + trainId, data, cb);
    }
    getAddTrain(data, cb) {
        this.post("/my/resume/trains", data, cb);
    }
    getDelTrain(trainId, cb) {
            this.deletes("/my/resume/train/" + trainId, cb);
        }
        //修改自我评价
    getEditIntroduction(data, cb) {
            this.put("/my/resume/introduction", data, cb);
        }
        //修改附加信息
    getAdditional(data, cb) {
            this.put("/my/resume/additional", data, cb);
        }
    //     //获取注册进展
    // getRegistProgress(cb) {
    //         this.get("/my/registerProgress", cb);
    //     }
        //初始化密码
    postInitpassword(data, cb) {
            this.post(`/my/init/password`, data, cb)
        }
        //登录之后创建名片信息
    postProfile(formItem, cb) {
        this.post("/my/profile", formItem, cb);
    }
    getProfile(cb) {
            this.get("/my/profile", cb);
        }
        //完善简历
    getResumeComplete(cb) {
        this.get("/my/resume/complete", cb);
    }
    postResumeComplete(formItem, cb) {
            this.post("/my/resume/complete", formItem, cb);
        }
        //求职意向
    getExpect(cb) {
        this.get("/my/expect", cb);
    }
    postExpect(formItem, cb) {
            this.post("/my/expect", formItem, cb);
        }
        // ------------------------- 简历权限设置---------------------------
        //目前年薪显示
    getResumesettingSalary(data, cb) {
            this.put(`/my/resume/salaryView`, data, cb);
        }
        //简历对企业设置
    getResumesettingcompanyStatus(data, cb) {
            this.put(`/my/resume/companyStatus`, data, cb);
        }
        //简历联系时间设置
    getResumesettingcontactTime(data, cb) {
            this.put(`/my/resume/contactTime`, data, cb);
        }
        //简历联系方式设置
    getResumesettingcontactWay(data, cb) {
            this.put(`/my/resume/contactWay`, data, cb);
        }
        //简历姓名显示
    getResumesettingname(data, cb) {
            this.put(`/my/resume/nameView`, data, cb);
        }
        //简历开放状态设置
    getResumesettingresumeViewStatus(data, cb) {
            this.put(`/my/resume/viewStatus`, data, cb);
        }
        //简历权限
    getResumesettingpermissions(cb) {
            this.get("/my/resume/permissions", cb);
        }
        // ------------------------- 猎头主页---------------------------
        //[求职者-人才服务][求职者]查看猎头主页猎头相关信息
    getHunterHomeHunter(hunterName, cb) {
            this.get("/applicant/hunter/" + hunterName + "/home/hunter", cb);
        }
        //[求职者-人才服务][求职者]查看猎头主页中运作中的职位
    getHunterHomePosition(data, cb) {
            this.get(
                "/applicant/hunter/" +
                data.hunterName +
                "/home/position?pageSize=5&pageNum=" +
                data.pageNum,
                cb
            );
        }
        //[求职者-人才服务][求职者]查看猎头主页中猎头公司
    getHunterHomeCompany(hunterName, cb) {
            this.get("/applicant/hunter/" + hunterName + "/home/company", cb);
        }
        //[求职者服务][求职者]查看猎头主页中相似猎头
    getHunterHomeRecommendHunter(data, cb) {
            this.get(
                "/applicant/hunter/" +
                data.hunterName +
                "/home/recommendHunter?pageSize=6&pageNum=" +
                data.pageNum,
                cb
            );
        }
        // getHunterHomeRecommendHunter(data, cb) {
        // 	this.get(
        // 		"/applicant/hunter/" +
        // 		data.hunterName +
        // 		"/home/recommendHunter?pageSize=6&pageNum=" +
        // 		data.pageNum,
        // 		cb
        // 	);
        // }
    //[求职者-猎头服务]求职者把简历委托给猎头
    postHunterDelegate(data, cb) {
        this.post("/applicant/hunter/delegate", data, cb);
    }
    //[求职者-猎头服务]求职者取消给某一个猎头的委托
    delHunterDelegate(hunterName, cb) {
        this.deletes("/applicant/hunter/" + hunterName + "/delegate", cb);
    }
    //[求职者-人才服务][求职者]查看猎头主页中服务公司统计
    getHunterHomeServiceCompany(hunterName, cb) {
        this.get("/applicant/hunter/" + hunterName + "/home/serviceCompany", cb);
    }
    //[关注者][求职者]取消关注猎头
    delattention(data, cb) {
        this.deletes(
            `/attention/applicant/hunter/${data.attentionName}`,
            cb
        );
    }
    //[关注者][求职者]添加关注猎头
    addattention(data, cb) {
        this.post(`/attention/applicant/hunter`, data, cb);
    }
    //[关注者][求职者]添加关注猎头hr
    addhrattention(data, cb) {
        this.post(`/attention/hrs`, data, cb);
    }
    //[关注者][求职者]取消关注猎头hr
    delhrattention(data, cb) {
        this.deletes(
            `/attention/hr/${data.attentionName}`,
            cb
        );
    }
    getHunters(size, location, cb) {
        this.get(`/applicant/hunter/recommend?pageSize=${size}&location=${location}`, cb);
    }
    //求职者获取委托猎头
    getmydelegate(pageNum, status, cb) {
        if (status == 'all')
            this.get(`/applicant/delegate?pageNum=${pageNum}&pageSize=15`, cb)
        else
            this.get(`/applicant/delegate?pageNum=${pageNum}&pageSize=15&status=${status}`, cb)
    }
    //求职者获取我的关注
    getmyattention(pageNum, status, cb) {
        if (status == 'all')
            this.get(`/attention/applicant/list?pageNum=${pageNum}&pageSize=15`, cb)
        else
            this.get(`/attention/applicant/list?pageNum=${pageNum}&pageSize=15&status=${status}`, cb)
    }
    //相似猎头
    getrecommendHunter(hunterName, cb) {
        this.get(`/applicant/hunter/${hunterName}/home/recommendHunter?pageNum=1&pageSize=15`, cb)
    }
    // 屏蔽公司
    getcompanysearch(value, cb) {
        this.get(`/search/companies?companyName=${value}&pageNum=1&pageSize=15`, cb)
    }
        //全局意见反馈注意保持一致
    postsubmitsuggest(data, cb) {
        this.post(`/suggest/submit`, data, cb)
    }

    getdelegated(hunterName, cb) {
        this.get(`/applicant/delegated?hunterName=${hunterName}`, cb)
    }

    //求职者猎头详情发送日志
    postHunterLog(hunterName, cb) {
        this.posts(`/my/hunterLog/${hunterName}/send`, cb)
    }

    //职位搜索,下拉框,推荐职位
    getRecommendSearch(cb) {
        this.get(`/my/searchRecords`, cb)
    }

    //职位搜索, /my/expect/workPlace
    async getMyExpectplace(cb) {
        return await this.$http.get('/my/expect/workPlace');
    }

    //竞争力分析
    getCompetitiveAnalysis(positionId, cb) {
        this.get(`/competitive/analysis/${positionId}`, cb)
    }

}
class apiFactory {
    constructor() {

    }
    createApi(axios) {
        return new oc_api(axios)
    }
}
export default new apiFactory();
